import { getCommandKeys, getDefaultPhrases } from './speechToCommand'
import { ActionsList } from './tern+/CustomWards'

export const normalizeSpeech = (text) =>
    String(text ?? '')
        .normalize('NFC')
        .replace(/\s+/g, '')
        .toLowerCase()

const actionLabel = (action) =>
    ActionsList.find((item) => item.value === action)?.label || action

// First phrase that would fire two actions, or null.
export const findSpeechConflict = (wardsArray, language) => {
    const filled = (wardsArray || []).filter(
        (item) => item.text?.trim() && item.action?.trim()
    )
    const customised = new Set(filled.map((item) => item.action))
    const builtIn = {}
    getCommandKeys(language).forEach((action) => {
        builtIn[action] = getDefaultPhrases(
            action,
            language,
            customised.has(action)
        )
    })
    const seen = {}

    for (const item of filled) {
        const key = normalizeSpeech(item.text)

        const owner = Object.keys(builtIn).find(
            (action) =>
                action !== item.action &&
                builtIn[action].some((phrase) => normalizeSpeech(phrase) === key)
        )
        if (owner) {
            return {
                text: item.text.trim(),
                actions: [actionLabel(owner), actionLabel(item.action)],
                builtIn: true,
            }
        }

        if (seen[key] && seen[key].action !== item.action) {
            return {
                text: item.text.trim(),
                actions: [
                    actionLabel(seen[key].action),
                    actionLabel(item.action),
                ],
                builtIn: false,
            }
        }
        seen[key] = item
    }
    return null
}

export const describeSpeechConflict = ({ text, actions, builtIn }) =>
    builtIn
        ? `"${text}" is already a built-in command for ${actions[0]}, so it cannot also be used for ${actions[1]}. Use a different phrase.`
        : `"${text}" is assigned to both ${actions[0]} and ${actions[1]}. Each command can only be assigned to one action.`
